module.exports = {"542522100":"托林镇","542522200":"萨让乡","542522201":"达巴乡","542522202":"底雅乡","542522203":"香孜乡","542522204":"曲松乡","542522205":"楚鲁松杰乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542522.json
// module id = 2770
// module chunks = 0